module.exports = __webpack_public_path__ + "static/media/logo_al.a07f0e34.svg";